export default {
	UPDATE_SELECTEDASSISTANT: "UPDATE_SELECTEDASSISTANT"
};
